import { DrawingToolMenuItem } from './drawingToolMenu'
import FibonacciIcon from '../../../../assets/icons/drawingTools/fibonacci'
import TrendBasedFibonacciIcon from '../../../../assets/icons/drawingTools/trendBasedFibonacci'
import FibonacciCirclesIcon from '../../../../assets/icons/drawingTools/fibonacciCircles'
import GannFanIcon from '../../../../assets/icons/drawingTools/gannFan'

export const fibonacciToolMenuItems: DrawingToolMenuItem[] = [
    {
        drawingToolId: 'fibonacci',
        text: 'Fibonacci Retracement',
        icon: <FibonacciIcon />,
        drawingType: 'fibonacci',
        toolOptions: {}
    },
    {
        drawingToolId: 'trendBasedFibonacci',
        text: 'Trend Based Fibonacci',
        icon: <TrendBasedFibonacciIcon />,
        drawingType: 'trendBasedFibonacci',
        toolOptions: {}
    },
    {
        drawingToolId: 'fibonacciCircles',
        text: 'Fib. Circles',
        icon: <FibonacciCirclesIcon />,
        drawingType: 'fibonacciCircles',
        toolOptions: {}
    },
    {
        drawingToolId: 'gannFan',
        text: 'Gann Fan',
        icon: <GannFanIcon />,
        drawingType: 'gannFan',
        toolOptions: {}
    }
]